import React, { useState } from 'react';
import OtpInput from 'react-otp-input';
import { IoCloseSharp } from 'react-icons/io5';
import { PropsFromRedux } from '.';
import  './ChangeWalletPin.scss';
import { BeatLoader } from '../Spinners/Spinner';
import { API_KEYS } from '../../interfaces/api';


interface Props extends PropsFromRedux {}

const ChangeWalletPin: React.FC<Props> = ({ 
    resetApi,
    hideModal,
    showModal,
    modal,
    changePinState,
    changePin

 }) => {

  const [otp, setOtp] = useState('');

  const [newOtp, setNewOtp] = useState('');

React.useEffect(() => () => {
    resetApi(API_KEYS.CHANGE_USER_PIN);
 },
[resetApi]);

  const handleChange = (code:any) => { 
    setOtp(code)
   }

   const handleNewChange = (code:any) => { 
    setNewOtp(code)
   }
   const closeModal = () => {
    hideModal();
  };

  const changePinPayload = () => {
    if(otp.length === 4 && newOtp.length == 4){
        changePin({
            CustomerPin: otp,
            CustomerNewPin : newOtp
        })
      
    }
  }

  React.useEffect(()=> {
      if(!changePinState?.loading && changePinState?.success ){
        hideModal();
        showModal({
            component: 'PinSuccessfulModal',
            modalProps: {
              contentLabel: 'Wallet pin successful',
            }
        });
      }
  },[!changePinState?.loading, changePinState?.success, hideModal, showModal])
  
  // <ModalWrapper hideCloseButton hideModal={hideModal}>
  return(
    <div className="w-full px-8 bg-white lg:px-24 py-10 relative">
        <button type="button" aria-label="Close" onClick={closeModal}>
        <IoCloseSharp className="sticky sm:absolute cursor-pointer text-2xl top-0 left-full sm:left-auto sm:right-5 sm:top-5" />
      </button>
     <div className="w-full my-2 text-center">
         <h2 className="mb-1 text-2xl font-bold text-black">Change wallet pin</h2>
      </div>
      <div className="w-full max-w-md mx-auto mb-10 mt-8 text-sm">
        <p className="text-gray-500 my-4 ml-5">
            Enter your old pin
       </p>
       <div>
       {/* className="p-4 bg-gray-200 m-4" */}
       <OtpInput 
       inputStyle="otp-field"
        value={otp}
        onChange={handleChange}
        numInputs={4}
        isInputSecure={true}
        separator={<span> </span>}
      />
       </div>
      </div>

      <div className="w-full max-w-md mx-auto mb-10 text-sm">
        <p className="text-gray-500 my-4 ml-5">
            Enter your new pin
       </p>
       <div>
       {/* className="p-4 bg-gray-200 m-4" */}
       <OtpInput 
       inputStyle="otp-field"
        value={newOtp}
        onChange={handleNewChange}
        numInputs={4}
        isInputSecure={true}
        separator={<span> </span>}
      />
       </div>
      </div>
      <button className="w-full bg-secondary font-medium text-sm rounded text-white py-4" type="button" onClick={() => changePinPayload()}
      disabled={changePinState?.loading}>
      {changePinState?.loading ? <BeatLoader color="white" /> : 'Confirm'}</button>

  </div>
  );
  // </ModalWrapper>
};

export default ChangeWalletPin;
